import React from 'react'
import { Button, Input } from '@/shared/ui'

type Props = {
  month: string
  onMonthChange: (v: string) => void
  onRefresh: () => void
  loading?: boolean
}

export default function RevshareMasterHeader({ month, onMonthChange, onRefresh, loading }: Props) {
  return (
    <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
      <div className="space-y-1">
        <div className="text-sm font-medium text-foreground/80">Visao master</div>
        <p className="text-sm text-foreground/70">Resumo do mes, participantes e configuracao.</p>
      </div>

      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-end">
        <div className="flex items-center gap-2">
          <span className="text-sm text-foreground/70">Mes</span>
          <Input
            type="month"
            value={month}
            onChange={(e) => onMonthChange((e.target as HTMLInputElement).value)}
            className="h-10 w-[160px]"
          />
        </div>
        <Button onClick={onRefresh} disabled={!!loading}>
          {loading ? 'Atualizando...' : 'Atualizar'}
        </Button>
      </div>
    </div>
  )
}

